export enum DISABILITY_STATUS {
  hasDisabilityApproval06 = '06',
  hasDisabilityApproval14 = '14',
}
